import {
  RECORDING_SCHEDULE_DAY_KEYS,
  RECORDING_SCHEDULE_DAY_LABELS,
  SLOTS_PER_DAY,
} from "./recording-schedule.ts";
import type { RecordingScheduleSlots } from "../types/recordingSchedule.ts";

export function countSelectedScheduleSlots(slots: RecordingScheduleSlots): number {
  let count = 0;
  for (const day of RECORDING_SCHEDULE_DAY_KEYS) {
    for (let i = 0; i < SLOTS_PER_DAY; i += 1) {
      if (slots[day][i]) count += 1;
    }
  }
  return count;
}

export function formatScheduleSummary(
  slots: RecordingScheduleSlots | null,
  timezone: string | null,
): string {
  if (!slots) {
    return "No schedule configured";
  }
  const count = countSelectedScheduleSlots(slots);
  if (count === 0) {
    return "No windows selected";
  }
  const daysWithSlots = RECORDING_SCHEDULE_DAY_KEYS.filter((day) =>
    slots[day].some(Boolean),
  );
  const dayLabels = daysWithSlots
    .map((day) => RECORDING_SCHEDULE_DAY_LABELS[day])
    .join(", ");
  const tz = (timezone ?? "").trim() || "server default timezone";
  return `${count} half-hour window${count === 1 ? "" : "s"} · ${dayLabels} · ${tz}`;
}
